module.exports = __webpack_public_path__ + "img/miami.c93b867f.jpg";